import { UsePreviewResult } from './type'
import { useRouteExtract } from './useRouteExtract'

export const usePreview = (): UsePreviewResult => {
  const { pathSegments } = useRouteExtract()
  pathSegments.pop()
  pathSegments.push('preview')
  const previewPath = '/' + pathSegments.join('/')

  return {
    previewPath,
  }
}
